(function () {
  var KEY = 'gb_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function has(handle) { return read().indexOf(handle) > -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) {
      list.splice(i, 1);
    } else {
      list.unshift(handle);
      if (window.fbq) window.fbq('track', 'AddToWishlist', { content_ids: [handle], content_type: 'product' });
    }
    write(list);
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wish')) > -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-wish-label]');
      var text = on ? 'Saved to favorites' : 'Save to favorites';
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      if (el.textContent !== String(list.length)) el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-wish'));
    var grid = document.getElementById('VetroWishGrid');
    if (grid && !has(btn.getAttribute('data-wish'))) {
      var card = btn.closest('.vetro-wl__card');
      if (card) card.remove();
      if (!grid.children.length) renderEmpty();
    }
  }, true);

  // Koleksiyon filtreleri kartlari yeniden cizer — durum isaretlerini tazele
  var mo = new MutationObserver(function () { sync(); });
  document.addEventListener('DOMContentLoaded', function () {
    sync();
    mo.observe(document.body, { childList: true, subtree: true });
    renderPage();
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function renderEmpty() {
    var wrap = document.getElementById('VetroWishWrap');
    if (!wrap) return;
    wrap.querySelector('[data-wish-empty]').hidden = false;
  }

  function renderPage() {
    var grid = document.getElementById('VetroWishGrid');
    if (!grid) return;
    var list = read();
    if (!list.length) return renderEmpty();
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = '';
      items.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var title = p.title.split(',')[0];
        html += '<div class="vetro-wl__card">' +
          '<a class="vetro-wl__media" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="vetro-wish is-on" data-wish="' + esc(p.handle) + '" aria-label="Remove from favorites">' + heart() + '</button>' +
          '<a class="vetro-wl__title" href="/products/' + esc(p.handle) + '">' + esc(title) + '</a>' +
          '<p class="vetro-wl__price">From ' + money(p.price_min) + '</p>' +
          '<a class="vetro-wl__btn" href="/products/' + esc(p.handle) + '">Choose options</a>' +
          '</div>';
      });
      grid.innerHTML = html;
      if (!html) renderEmpty();
    });
  }

  function heart() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.6-9.2C.9 7.9 3 4.5 6.5 4.5c2 0 3.6 1.1 4.5 2.6.9-1.5 2.5-2.6 4.5-2.6 3.5 0 5.6 3.4 4.1 6.8C19.5 15.9 12 20.5 12 20.5z"/></svg>';
  }
})();
